module.exports = __webpack_public_path__ + "static/media/upload.5ce21467.svg";